import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { DsrIconsModule } from '@desyre/icons-angular';
import { DsrFooterComponent, DsrHeaderComponent, DsrModeSwitcherComponent } from '@desyre/angular-material';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { DsrFlagsModule } from '@desyre/icons-angular';
import { LoginModule } from '../features/login/login.module';
import { RouterModule } from '@angular/router';
import { NavMenuItemComponent } from './components/header/nav-menu-item/nav-menu-item.component';
import { ContactModule } from '../features/contact/contact.module';
import { AccessibilityMenuComponent } from './components/header/accessibility-menu/accessibility-menu.component';
import { UserMenuComponent } from './components/header/user-menu/user-menu.component';
import { LanguageMenuComponent } from './components/header/language-menu/language-menu.component';
import { TranslateModule } from '@ngx-translate/core';
import { LegalInformationPopupComponent } from './components/legal-information-popup/legal-information-popup.component';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavMenuItemComponent,
    AccessibilityMenuComponent,
    UserMenuComponent,
    LanguageMenuComponent,
    LegalInformationPopupComponent,
  ],
  imports: [
    CommonModule,
    DsrIconsModule,
    DsrFlagsModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    DsrHeaderComponent,
    DsrFooterComponent,
    DsrModeSwitcherComponent,
    LoginModule,
    ContactModule,
    RouterModule,
    TranslateModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
  ]
})

export class CoreModule { }